exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {

  if (location.hash) {
    window.history.scrollRestoration = 'auto'
    return true
  }

  window.history.scrollRestoration = 'manual'

  window.setTimeout(() => {
    window.requestAnimationFrame(() => {
      try {
        window.scrollTo({ top: 0, behavior: 'instant' })
      } catch (e) {
        window.scrollTo(0)
      }
    })
  }, 10)

  return false
}